export const classes = {
  card: 'place-between pl-4 pr-3 py-2 bg-grey-2 dark:bg-white/[0.06] hover:bg-grey-3 dark:hover:bg-white/[0.1] text-grey-8 dark:text-mauve-1 shadow-none my-2',
  content: 'place-start grow text-left outline-none cursor-pointer',
  title: 'pointer-events-none text-sm',
  subtitle: 'pointer-events-none font-light text-sm',
  details: 'pl-6 pr-4',
  closeIcon: 'close-icon text-grey-8 dark:text-mauve-1 transition-all',
};

export const styles = {
  card: {
    '&:hover .close-icon': {
      opacity: 1,
    },
    '& .close-icon': {
      opacity: 0,
    },
  },
};
